import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { ApiClient } from '../api'
import type { EventResourceAttach } from '../types'

// Per-event resources hook set (Live View PR L1 / spec 23). Cache key is
// per-event so opening the panel on event A doesn't refetch event B's
// list. Mutations invalidate the same key on success.

export function useEventResources(eventId: number) {
  return useQuery({
    queryKey: ['event-resources', eventId],
    queryFn: () => ApiClient.eventResources(eventId),
    enabled: Number.isFinite(eventId) && eventId > 0,
    staleTime: 60_000
  })
}

export function useAttachEventResource(eventId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: EventResourceAttach) =>
      ApiClient.attachEventResource(eventId, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['event-resources', eventId] })
  })
}

export function useDetachEventResource(eventId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (resourceId: number) =>
      ApiClient.detachEventResource(eventId, resourceId).then(() => resourceId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['event-resources', eventId] })
  })
}
